<app-replenish-your-good-bacteria>
  <p class="mb-4">
    When your digestion is balanced, bathroom trips are gentler and less stressful. Probiotics work from the inside out
    to:
  </p>
  <ul class="mb-4 unordered-list" data-qa-id="Probiotics Benefits List">
    <li>Support smooth, regular bowel movements</li>
    <li>Reduce bloating and discomfort that can worsen strain</li>
    <li>Improve stool consistency during recovery</li>
    <li>Help prevent future irritation</li>
  </ul>
  <p class="mb-4">
    <strong>
      A daily probiotic is a simple way to make your healing more comfortable—and protect against flare-ups down the
      road.
    </strong>
  </p>
</app-replenish-your-good-bacteria>
